import { useLocation, useNavigate, useParams } from 'react-router'

import { documentRoute, routes } from '@/app/routes'
import { SurveyRunner } from '@/features/survey/SurveyRunner'

export function SurveyPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { tag = '' } = useParams<{ tag: string }>()

  const back = (location.state as { back?: string } | null)?.back ?? routes.dashboard

  return (
    <main className="stage-screen">
      <SurveyRunner
        tag={tag}
        onLeave={() => void navigate(back)}
        onDocument={(documentId) => void navigate(documentRoute(documentId), { replace: true })}
        onQuota={() => void navigate(routes.subscription)}
      />
    </main>
  )
}
